export const DASHBOARD_VALID_TABS = [
  'live',
  'manage',
  'appointments',
  'services',
  'service-catalog',
  'employees',
  'analytics',
  'store-health',
  'offers',
  'customer-reviews',
  'qr-posters',
  'memberships',
];

export const normalizeDashboardTab = (rawTab, servicesEmployeesRolesEnabled) => {
  const value = String(rawTab || '').trim();
  if (value === 'employees' && !servicesEmployeesRolesEnabled) return 'live';
  if (value === 'service-catalog') return 'service-catalog';
  if (value === 'services') return 'services';
  return DASHBOARD_VALID_TABS.includes(value) ? value : 'live';
};
